import { getCountries } from "@/api/countries.api";

export const fetchCountries = async ({ commit }) => {
  const countries = await getCountries();

  commit("setCountries", countries);
};
